var map = {
	"./Algeria-DZ.svg": [
		18373,
		8373
	],
	"./Angola-AO.svg": [
		50592,
		592
	],
	"./Argentina-AR.svg": [
		33493,
		3493
	],
	"./Australia-AU.svg": [
		39706,
		9706
	],
	"./Austria-AT.svg": [
		91944,
		1944
	],
	"./Azerbaijan-AZ.svg": [
		94603,
		4603
	],
	"./Bahrain-BH.svg": [
		29929,
		9929
	],
	"./Bangladesh-BD.svg": [
		54630,
		4630
	],
	"./Belarus-BY.svg": [
		35353,
		5353
	],
	"./Belgium-BE.svg": [
		70259,
		259
	],
	"./Bolivia-BO.svg": [
		94762,
		4762
	],
	"./Brazil-BR.svg": [
		64398,
		4398
	],
	"./Bulgaria-BG.svg": [
		57561,
		7561
	],
	"./Cambodia-KH.svg": [
		91512,
		1512
	],
	"./Cameroon-CM.svg": [
		82698,
		2698
	],
	"./Canada-CA.svg": [
		60973,
		973
	],
	"./Chile-CL.svg": [
		63888,
		3888
	],
	"./China-CN.svg": [
		9679,
		9679
	],
	"./Colombia-CO.svg": [
		62937,
		2937
	],
	"./Costa-Rica-CR.svg": [
		14743,
		4743
	],
	"./Cote-d'Ivori-CI.svg": [
		74819,
		4819
	],
	"./Croatia-HR.svg": [
		70096,
		96
	],
	"./Czech-Republic-CZ.svg": [
		76496,
		6496
	],
	"./Denmark-DK.svg": [
		77121,
		7121
	],
	"./Dominican-Republic-DO.svg": [
		53218,
		3218
	],
	"./Ecuador-EC.svg": [
		56045,
		6045
	],
	"./Egypt-EG.svg": [
		94429,
		4429
	],
	"./El-Salvador-SV.svg": [
		75900,
		5900
	],
	"./Eritrea-ER.svg": [
		36367,
		6367
	],
	"./Estonia-EE.svg": [
		18337,
		8337
	],
	"./European-Union-EU.svg": [
		71513,
		1513
	],
	"./Finland-FI.svg": [
		82025,
		2025
	],
	"./France-FR.svg": [
		59589,
		9589
	],
	"./France-britain-split.svg": [
		28178,
		8178
	],
	"./Gabon-GA.svg": [
		20635,
		635
	],
	"./Georgia-GE.svg": [
		57301,
		7301
	],
	"./Germany-DE.svg": [
		37188,
		7188
	],
	"./Greece-GR.svg": [
		51879,
		1879
	],
	"./Greenland-GL.svg": [
		75296,
		5296
	],
	"./Guadeolupe-GP.svg": [
		81619,
		1619
	],
	"./Guatemala-GT.svg": [
		64235,
		4235
	],
	"./Honduras-HN.svg": [
		57760,
		7760
	],
	"./Hong-Kong-HK.svg": [
		59627,
		9627
	],
	"./Hungary-HU.svg": [
		16655,
		6655
	],
	"./India-IN.svg": [
		37565,
		7565
	],
	"./Indonesia-ID.svg": [
		36644,
		6644
	],
	"./Iran-IR.svg": [
		61592,
		1592
	],
	"./Iraq-IQ.svg": [
		31339,
		1339
	],
	"./Ireland-IE.svg": [
		47846,
		7846
	],
	"./Israel-IL.svg": [
		77803,
		7803
	],
	"./Italy-IT.svg": [
		60682,
		682
	],
	"./Japan-JP.svg": [
		41130,
		1130
	],
	"./Jordan-JO.svg": [
		75516,
		5516
	],
	"./Kazakhstan-KZ.svg": [
		21692,
		1692
	],
	"./Kenya-KE.svg": [
		49960,
		9960
	],
	"./Kuwait-KW.svg": [
		42950,
		2950
	],
	"./Kyrgystan-KG.svg": [
		60796,
		796
	],
	"./Libya-LY.svg": [
		31610,
		1610
	],
	"./Luxembourg-LU.svg": [
		29537,
		9537
	],
	"./Malaysia-MY.svg": [
		45950,
		5950
	],
	"./Malta-MT.svg": [
		42331,
		2331
	],
	"./Martinique-MQ.svg": [
		26865,
		6865
	],
	"./Mexico-MX.svg": [
		69866,
		9866
	],
	"./Morroco-MA.svg": [
		77423,
		7423
	],
	"./Mozambique-MZ.svg": [
		33885,
		3885
	],
	"./Netherlands-NL.svg": [
		87428,
		7428
	],
	"./New-Zealand-NZ.svg": [
		98404,
		8404
	],
	"./Nigeria-NG.svg": [
		62024,
		2024
	],
	"./Norway-NO.svg": [
		92686,
		2686
	],
	"./Oman-OM.svg": [
		42321,
		2321
	],
	"./Pakistan-PK.svg": [
		29162,
		9162
	],
	"./Palestine-PS.svg": [
		61584,
		1584
	],
	"./Panama-PA.svg": [
		76537,
		6537
	],
	"./Peru-PE.svg": [
		64822,
		4822
	],
	"./Philippines-PH.svg": [
		73802,
		3802
	],
	"./Poland-PL.svg": [
		79669,
		9669
	],
	"./Portugal-PT.svg": [
		58660,
		8660
	],
	"./Puerto-Rico-PR.svg": [
		95651,
		5651
	],
	"./Qatar-QA.svg": [
		42219,
		2219
	],
	"./Rainbow.svg": [
		39625,
		9625
	],
	"./Reunion-RE.svg": [
		19199,
		9199
	],
	"./Romania-RO.svg": [
		5567,
		5567
	],
	"./Russia-RU.svg": [
		36126,
		6126
	],
	"./Saudi-Arabia-SA.svg": [
		46191,
		6191
	],
	"./Senegal-SN.svg": [
		58374,
		8374
	],
	"./Serbia-RS.svg": [
		5053,
		5053
	],
	"./Singapore-SG.svg": [
		50114,
		114
	],
	"./Slovakia-SK.svg": [
		75505,
		5505
	],
	"./Slovenia-SI.svg": [
		1999,
		1999
	],
	"./South-Africa-ZA.svg": [
		69107,
		9107
	],
	"./South-Korea-KR.svg": [
		34003,
		4003
	],
	"./Spain-ES.svg": [
		54252,
		4252
	],
	"./Sudan-SD.svg": [
		20649,
		649
	],
	"./Sweden-SE.svg": [
		33548,
		3548
	],
	"./Switzerland-CH.svg": [
		94862,
		4862
	],
	"./Syria-SY.svg": [
		93087,
		3087
	],
	"./Taiwan-TW.svg": [
		5361,
		5361
	],
	"./Thailand-TH.svg": [
		78485,
		8485
	],
	"./Tunisia-TN.svg": [
		22526,
		2526
	],
	"./Turkey-TR.svg": [
		8425,
		8425
	],
	"./Ukraine-UA.svg": [
		90882,
		882
	],
	"./United-Arab-Emirates-AE.svg": [
		77364,
		7364
	],
	"./United-Kingdom-GB.svg": [
		61156,
		1156
	],
	"./United-States-US.svg": [
		78916,
		8916
	],
	"./Uruguay-UY.svg": [
		72366,
		2366
	],
	"./Uzbekistan-UZ.svg": [
		4239,
		4239
	],
	"./Venezuela-VE.svg": [
		75829,
		5829
	],
	"./Vietnam-VN.svg": [
		38677,
		8677
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53520;
module.exports = webpackAsyncContext;